export enum TaskStatus {
  Completed = 'completed',
  New = 'new',
}
